namespace RioERP.Administration {
    export class LanguageColumns {
        static columnsKey = 'Administration.Language';
    }
}
